module.exports = __webpack_public_path__ + "img/10.3cb86f40.jpg";